import './sub-components/al-guestlist-grid-entry/component';
import template from './component.tpl.html';
import AlGuestlistsGridViewController from './controller';

angular
    .module('festzelt-os.modules.guestlists')
    .component('alGuestlistsGridView', {
        bindings: {
            hideHeader: '<',
            onSwitchToListView:'&'
        },
        controller: AlGuestlistsGridViewController,
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/components/al-guestlists-grid-view/component.js